"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AssetRegistry_1 = require("@dialogexe/cw-asset-provider/core/AssetRegistry");
AssetRegistry_1.default.register('arrow-left-white', require('./img/arrow-left-white.svg'));
AssetRegistry_1.default.register('arrow-right-white', require('./img/arrow-right-white.svg'));
AssetRegistry_1.default.register('arrowhead-down', require('./img/arrowhead-down.svg'));
AssetRegistry_1.default.register('arrowhead-down-white', require('./img/arrowhead-down-white.svg'));
AssetRegistry_1.default.register('arrowhead-right', require('./img/arrowhead-right.svg'));
AssetRegistry_1.default.register('arrow-left', require('./img/arrow-left.svg'));
AssetRegistry_1.default.register('arrow-left-inactive', require('./img/arrow-left-inactive.svg'));
AssetRegistry_1.default.register('arrow-right', require('./img/arrow-right.svg'));
AssetRegistry_1.default.register('arrow-right-inactive', require('./img/arrow-right-inactive.svg'));
AssetRegistry_1.default.register('play', require('./img/play.svg'));
AssetRegistry_1.default.register('star-yellow', require('./img/star-yellow.svg'));
AssetRegistry_1.default.register('star-empty', require('./img/star-empty.svg'));
AssetRegistry_1.default.register('search-big', require('./img/search-big.svg'));
AssetRegistry_1.default.register('search', require('./img/search.svg'));
AssetRegistry_1.default.register('hamburger', require('./img/hamburger.svg'));
AssetRegistry_1.default.register('close', require('./img/close.svg'));
AssetRegistry_1.default.register('close-white', require('./img/close-white.svg'));
AssetRegistry_1.default.register('close-white-small', require('./img/close-white-small.svg'));
AssetRegistry_1.default.register('kinoklubb-black', require('./img/kinoklubb-black.png'));
AssetRegistry_1.default.register('exclamation', require('./img/exclamation.svg'));
AssetRegistry_1.default.register('profile', require('./img/profile.svg'));
AssetRegistry_1.default.register('e-remove', require('./img/e-remove.svg'));
AssetRegistry_1.default.register('frame-c-arrow-right', require('./img/frame-c-arrow-right.svg'));
AssetRegistry_1.default.register('event-ticket', require('./img/event-ticket.svg'));



// WEBPACK FOOTER //
// ./src/layouts/assets/icons.ts